import './header.css';
import { ExIcon, IconSize } from '@boomi/exosphere';
import type { JwtToken } from '../../types/global';
import AccountMenu from './AccountMenu';
import ProductsMenu from './ProductsMenu';

const Header = ({ jwt }: { jwt: JwtToken }) => {
    return (
        <div className="header">
            <a className="header-link" href="/">
                <img className="boomi-logo" src="/img/b-mark.svg" alt="Boomi logo" />
                <span className="product-title">Task Inbox</span>
            </a>
            <div className="right-header-buttons">
                <a
                    className="help-button"
                    title="Help"
                    href="https://help.boomi.com"
                    target="_blank"
                >
                    <ExIcon icon="Help" size={IconSize.M} />
                </a>
                <a
                    className="boomi-ai-button"
                    title="Boomi AI"
                    href="https://platform.boomi.com/BoomiAI.html#boomiAi"
                    target="_blank"
                >
                    <img
                        className="boomi-ai-icon"
                        src="/img/boomi-ai-animated-icon.svg"
                        alt="Boomi AI icon"
                    />
                </a>
                <ProductsMenu />
                <AccountMenu jwt={jwt} />
            </div>
        </div>
    );
};

export default Header;
